import PropTypes from 'prop-types';
import React from 'react';
import CheckBox from 'yoda-core-components/lib/components/CheckBox';
import {
    SET_EXPRESS_CHECKOUT,
    SAVE_DEFAULT_PAYMENT,
} from 'yoda-checkout-components/lib/common/LabelConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './OptinForExpressCheckout.css';

function OptinForExpressCheckout(props) {
    const checkboxConfig = {
        id: 'optinForExpressCheckout',
        'data-automation-id': 'set-express-checkout',
        defaultChecked: props.defaultExpressCheckout,
    };
    return (
        <div className={`${styles.expCheckCont} ${dt(['float-left', 'mt-6'])}`}>
            <CheckBox
                id={checkboxConfig.id}
                name={checkboxConfig.id}
                label={SET_EXPRESS_CHECKOUT}
                checked={checkboxConfig.defaultChecked}
                onClick={props.handleExpressCheckout}
                automationId="at-express-checkout-chkbox"
                size="Lg"
            />
            <div data-automation-id="save-default-payment" className={dt(['mt-4', 'text-sm'])}>
                {SAVE_DEFAULT_PAYMENT}
            </div>
        </div>
    );
}

OptinForExpressCheckout.propTypes = {
    defaultExpressCheckout: PropTypes.bool.isRequired,
    handleExpressCheckout: PropTypes.func.isRequired,
};

export default OptinForExpressCheckout;
